import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';
import './Contact.css';

const Contact = () => {
    const recaptchaRef = useRef(null);
  
    const handleSubmit = (e) => {
      e.preventDefault();
  
      const form = e.target;
      const name = form.name.value.trim();
      const email = form.email.value.trim();
      const message = form.message.value.trim();
    
      if (!name || !email || !message) {
        alert("Please fill in all fields.");
        return;
      }
    
      if (!/\S+@\S+\.\S+/.test(email)) {
        alert("Please enter a valid email address.");
        return;
      }
  
      if (!recaptchaRef.current) {
        alert('reCAPTCHA failed to load. Please refresh the page and try again.');
        return;
      }
  
      const recaptchaValue = recaptchaRef.current.getValue();
      if (!recaptchaValue) {
        alert('Please complete the reCAPTCHA verification.');
        return;
      }
  
      const formData = new FormData(e.target);
      formData.append('g-recaptcha-response', recaptchaValue);
  
      emailjs.sendForm(
        process.env.REACT_APP_SERVICE_ID, // Replace with your EmailJS service ID
        process.env.REACT_APP_TEMPLATE_ID, // Replace with your EmailJS template ID
        e.target,
        process.env.REACT_APP_PUBLIC_KEY // Replace with your EmailJS public key
      )
      .then((result) => {
        alert("Message sent successfully!");
        e.target.reset(); // Reset the form
      }, (error) => {
        alert("Failed to send message. Please try again.");
        console.error(error.text);
      });
    };
  
    return (
      <section id="contact" className="contact-section">
        <h1 class="contact-title-box">Contact</h1>
        <div className="contact-container">
          <div className="about-me">
            <h2>About Me</h2>
            <p>
              - A 2020 graduate from the University of Derby. I am a software developer fortunate to have been exposed to a diverse set of technologies that fueled a never ending drive to expand my experience across the modern tech spectrum.<br></br>
              <br></br>
              - I've primary worked around backend RESTful API web applications contributing with maintenance, bug fixing, development of new features and test coverage. Both self-hosted projects and on the AWS cloud.<br></br>
              <br></br>
              - I've participated in database management procedures such as query optimization and data migrations.<br></br>
              <br></br>
              - In my spare time I've have been offering freelance data analytics services around extracting and presenting insights from large datasets, as well as building detailed and intuitive dashboards using Power BI and Python with libraries such as matplotlib and seaborn.
            </p>
          </div>
          <div className="contact-form">
            <h2>Get in Touch</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <div class="label-container">
                  <img src="/icons/user.png" alt="User Icon" className="contact-icon" />
                  <label class="label" htmlFor="name">Name</label>
                </div>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <div class="label-container">
                  <img src="/icons/gmail.png" alt="Gmail Icon" className="contact-icon" />
                  <label class="label" htmlFor="email">Email</label>
                </div>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <div class="label-container">
                  <img src="/icons/comments.png" alt="Comments Icon" className="contact-icon" />
                  <label class="label" htmlFor="message">Message</label>
                </div>
                <textarea id="message" name="message" rows="5" required></textarea>
              </div>
              <div className="form-group">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                />
              </div>
              <button type="submit" className="submit-button">Send Message</button>
            </form>
          </div>
        </div>
      </section>
    );
  };

  export default Contact;